/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputTargetImport
 */
export interface InputTargetImport {
    /**
     * 
     * @type {Array<string>}
     * @memberof InputTargetImport
     */
    targets: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof InputTargetImport
     */
    zoneId: number;
}

/**
 * Check if a given object implements the InputTargetImport interface.
 */
export function instanceOfInputTargetImport(value: object): boolean {
    if (!('targets' in value)) return false;
    if (!('zoneId' in value)) return false;
    return true;
}

export function InputTargetImportFromJSON(json: any): InputTargetImport {
    return InputTargetImportFromJSONTyped(json, false);
}

export function InputTargetImportFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputTargetImport {
    if (json == null) {
        return json;
    }
    return {
        
        'targets': json['targets'],
        'zoneId': json['zone_id'],
    };
}

export function InputTargetImportToJSON(value?: InputTargetImport | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'targets': value['targets'],
        'zone_id': value['zoneId'],
    };
}

